import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4235d6b5"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "latest-transactions__title" }, "آخرین تراکنش ها:", -1))
const _hoisted_2 = { class: "latest-transactions" }
const _hoisted_3 = { class: "latest-transactions__row" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "latest-transactions__head" }, "مقدار (USDT)", -1))
const _hoisted_5 = { class: "latest-transactions__col" }
const _hoisted_6 = { class: "latest-transactions__row" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "latest-transactions__head" }, "زمان", -1))
const _hoisted_8 = { class: "latest-transactions__col" }
const _hoisted_9 = { class: "latest-transactions__row" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "latest-transactions__head" }, "هش تراکنش", -1))
const _hoisted_11 = { class: "latest-transactions__col" }
const _hoisted_12 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: _normalizeClass([
            'latest-transactions__value',
            item.type === 'buy'
              ? 'latest-transactions__value--success'
              : 'latest-transactions__value--danger',
          ])
            }, _toDisplayString(item.amount.toLocaleString()), 3))
          }), 128))
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createElementVNode("div", _hoisted_8, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item, index) => {
            return (_openBlock(), _createElementBlock("div", { key: index }, _toDisplayString(item.time), 1))
          }), 128))
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _hoisted_10,
        _createElementVNode("div", _hoisted_11, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item, index) => {
            return (_openBlock(), _createElementBlock("a", {
              href: item.link,
              target: "_blank",
              key: index,
              class: "latest-transactions__hash"
            }, _toDisplayString(item.hash), 9, _hoisted_12))
          }), 128))
        ])
      ])
    ])
  ], 64))
}